import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import CustomModal from '@/components/shared/CustomModal/CustomModal'
import { Table } from '@components/shared/Table'
import './ViewTractRunsheetsModal.css'

/* type ViewTractRunsheetsProps = {
    tract: Tract
    show: boolean
    showHide: (showAdd: boolean) => void
    showHideAddRunsheet: (showAdd: boolean) => void
    runsheets: Runsheet[]
} */

export const ViewTractRunsheetsModal = ({
    tract,
    show,
    showHide,
    showHideAddRunsheet,
    runsheets,
}) => {
    
    const handleModal = () => {
        showHide(!show)
    }
    
    const rows = useMemo(
        () =>
            runsheets?.map(runsheet => {
                let assignedTo = ''
                
                if (runsheet.assignedTo?.length) {
                    assignedTo = `${runsheet.assignedTo[0].firstName || ''} ${runsheet.assignedTo[0].lastName || ''}`
                }
                
                return [
                    runsheet.name || '',
                    `${runsheet.grossAcreage || ''}`,
                    assignedTo,
                    <Link
                        key={`runsheet-link-${runsheet.id}`}
                        className="btn btn-primary  btn-sm"
                        to={`/runsheet/${runsheet.id}/${tract.id}`}>
                        View
                    </Link>,
                ]
            }),
        [runsheets, tract.id],
    )
    
    return (
        <CustomModal
            open={show}
            modalHandler={() => handleModal()}
            center
            modalClass="assign-tract-to-runsheet">
            
            <div className="modal-header">
                <h2 className="modal-title">Runsheets</h2>
            </div>
            
            <div className="modal-body">
                <Table
                    isButton={false}
                    setShowTable={() => {}}
                    setAssignTractsList={() => {}}
                    setIsAddTract={() => {}}
                    prefix="assign-tract-to-runsheet-list"
                    style={{ overflow: 'hidden' }}
                    cardHeader={
                        <div className="flex">
                            <button
                                type="submit"
                                className="btn btn-primary btn-outline mr-3 ml-3"
                                onClick={handleModal}>
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary mr-3"
                                onClick={() => {
                                    showHideAddRunsheet(true)
                                    handleModal()
                                }}>
                                Add Runsheet
                            </button>
                        </div>
                    }
                    headers={['Runsheet Name', 'Gross Acreage', 'Assigned to', 'Action']}
                    sortHeaders={['item-timestamp', 'item-firstName', 'item-lastName', 'item-action']}
                    rows={rows} />
            </div>
        </CustomModal>
    )
}
